class Slideshow {
	constructor(element) {
		this.slideshow = element;
		this.container = element.querySelector('.slideshowContainer');
		this.slides = element.querySelectorAll('.slide');
		this.prevButton = element.querySelector('.slideshowPrev');
		this.nextButton = element.querySelector('.slideshowNext');
		this.dots = element.querySelector('.slideshowDot');

		this.currentSlide = 0;
		this.slideCount = this.slides.length;
		this.autoplay = element.dataset.autoplay === 'true';
		this.autplaySpeed = parseInt(element.dataset.autoplaySpeed) || 5000;
		this.autoplayInterval = null;

		this.init();
	}

	init() {
		if (this.slideCount === 0) return;

		this.showSlide(0);

		if (this.prevButton) {
			this.prevButton.addEventListener('click', () => this.prevSlide());
		}

		if (this.nextButton) {
			this.nextButton.addEventListener('click', () => this.nextSlide());
		}

		if (this.dots.length > 0) {
			this.dots.forEach((dot, index) => {
				dot.addEventListener('click', () => this.showSlide(index));
			});
		}

		if (this.autoplay) {
			this.startAutoplay();

			this.slideshow.addEventListener('mouseenter', () =>
				this.stopAutoplay()
			);
			this.slideshow.addEventListener('mouseleave', () =>
				this.startAutoplay()
			);
		}

		let touchStartX = 0;
		let touchEndX = 0;

		this.slideshow.addEventListener(
			'touchstart',
			e => {
				touchstartX = e.changedTouches[0].screenX;
			},
			{ passive: true }
		);

		this.slideshow.addEventListener(
			'touchend',
			e => {
				touchEndX = e.changedTouches[0].screenX;
				this.handleSwipe(touchStartX, touchEndX);
			},
			{ passive: true }
		);
	}

	showSlide(index) {
		if (index < 0) index = this.slideCount - 1;
		if (index >= this.slideCount) index = 0;

		this.slides.forEach((slide, i) => {
			if (i === index) {
				slide.classList.add('active');
				slide.style.opactiy = '1';
				slide.style.visibility = 'visible';
			} else {
				slide.classList.remove('active');
				slide.style.opacity = '0';
				slide.style.visibility = 'hidden';
			}
		});

		if (this.dots.length > 0) {
			this.dots.forEach((dot, i) => {
				if (i === index) {
					dot.classList.add('active');
				} else {
					dot.classList.remove('active');
				}
			});
		}

		this.currentSlide = index;
	}

	nextSlide() {
		this.showSlide(this.currentSlide + 1);
		this.resetAutoplay();
	}

	prevSlide() {
		this.showSlide(this.currentSlide - 1);
		this.resetAutoplay();
	}

	handleSwipe(start, end) {
		const swipeThreshold = 50;
		const diff = end - start;

		if (Math.abs(diff) > swipeThreshold) {
			if (diff > 0) {
				this.prevSlide();
			} else {
				this.nextSlide();
			}
		}
	}

	startAutoplay() {
		if (!this.autoplay) return;
		this.stopAutoplay();
		this.autoplayInterval = setInterval(() => {
			this.nextSlide();
		}, this.autoplaySpeed);
	}

	stopAutoplay() {
		if (this.autoplayInterval) {
			clearInterval(this.autoplayInterval);
			this.autoplayInterval = null;
		}
	}

	resetAutoplay() {
		if (this.autoplay) {
			this.stopAutoplay();
			this.startAutoplay();
		}
	}
}

document.addEventListener('DOMContentLoaded', () => {
	const slideshows = document.querySelectorAll('.slideshow');
	slideshows.forEach(slideshow => new Slideshow(slideshow));
});
